import { render } from "./ProjectDonationTable.vue?vue&type=template&id=8f9198e8"
import script from "./ProjectDonationTable.vue?vue&type=script&lang=js"
export * from "./ProjectDonationTable.vue?vue&type=script&lang=js"
script.render = render

export default script